<template>
  <div id="order-list" v-loading="loading">
    <form class="row search-pannel" :class="{ fold: fold}" @submit.prevent="doQuery">
      <input type="submit" style="display:none" />
      <div class="col-sm-3">
        <el-input size="small" v-model="query.orderSn" placeholder="订单编号" @input="(val) => query.orderSn = val.replace(/\s/g, '')" />
      </div>
      <div class="col-sm-3">
        <el-select size="small" v-model="query.brand" placeholder="配件品牌" multiple>
          <el-option v-for="b in orderBrands" :label="b.name" :value="b.code" :key="b.code" />
        </el-select>
      </div>
      <div class="col-sm-3">
        <el-input size="small" v-model="query.part" placeholder="配件编号/配件名称" @input="(val) => query.part = val.replace(/\s/g, '')" />
      </div>
      <div class="col-sm-3">
        <el-input size="small" v-model="query.buyer" placeholder="买家名称/买家手机号" />
      </div>
      <div class="col-sm-2">
        <el-select size="small" v-model="query.orderType" placeholder="订单类型" clearable>
          <el-option label="全部订单" :value="0" />
          <el-option label="普通订单" :value="1" />
          <el-option label="大库订单" :value="2" />
          <el-option label="询价订单" :value="3" />
          <el-option label="反向订单" :value="4" />
        </el-select>
      </div>
      <div class="col-sm-3">
        <el-date-picker size="small" v-model="query.timePayStart" value-format="yyyy-MM-dd" placeholder="付款时间-开始" clearable>
        </el-date-picker>
      </div>
      <div class="col-sm-3">
        <el-date-picker size="small" v-model="query.timePayEnd" value-format="yyyy-MM-dd" placeholder="付款时间-结束" clearable>
        </el-date-picker>
      </div>
      <div class="col-sm-2">
        <el-select size="small" v-model="query.warehouse" placeholder="发货仓库" clearable>
          <el-option v-for="r in repos" :key="r" :label="r" :value="r">
          </el-option>
        </el-select>
      </div>
      <div class="col-sm-2">
        <el-select size="small" v-model="query.subSellerId" placeholder="卖家" clearable>
          <el-option v-for="s in subSellers" :key="s.id" :label="s.name" :value="s.id">
          </el-option>
        </el-select>
      </div>
      <div class="folder">
        <el-button type="primary" size="small" @click="doQuery">确定</el-button>
        <el-button type="default" size="small" @click="doReset">重置</el-button>
        <el-button style="float: right" size="small" type="text" @click="fold = !fold">{{ fold ? '展开' : '收起' }}<i v-if="fold" class="crm-icon-arrow-down" /><i v-else class="crm-icon-arrow-up" /></el-button>
      </div>
    </form>
    <div class="state-grouper">
      <div>
        <div
          v-for="state in orderStateEnums"
          class="state"
          :class="{ current: state.id === query.orderState }"
          :key="state.id"
          @click="updateState(state.id)"
        >
          {{ state.name }}
          <template v-if="calcStateCount(state.id) > 0">({{ calcStateCount(state.id) }})</template>
        </div>
      </div>
    </div>
    <div v-if="list && list.length" class="data-list">
      <div v-for="item in list" :key="item.id" class="order-item-wraper">
        <order-item :order="item" @startLoading="loading = true" @endLoading="loading=false" />
      </div>
    </div>
    <div v-else class="data-list">
      <div class="no-data">
        暂无数据
      </div>
    </div>
    <div class="page-footer">
      <el-pagination
        background
        layout="prev, pager, next"
        :pager-count="5"
        :current-page.sync="pagination.pageIndex"
        :total="pagination.totalCount"
        :page-size.sync="pagination.pageSize"
        @current-change="updateRoute"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import OrderItem from './partials/OrderItem.vue'
import { ListOrder, LoadOpsInfo, LoadSourceInfo } from './services'
import _ from 'lodash'
import Config from '@/config'
export default {
  name: 'Order',
  components: { OrderItem },
  data () {
    return {
      fold: true,
      loading: false,
      // repos,
      query: {
        orderSn: undefined,
        part: undefined,
        brand: undefined,
        buyer: undefined,
        recieve: undefined,
        orderType: undefined,
        orderState: undefined,
        timePayStart: undefined,
        timePayEnd: undefined,
        warehouse: undefined,
        subSellerId: undefined
      },
      statistics: [],
      list: [],
      pagination: {
        pageIndex: 1,
        pageSize: 20,
        totalCount: 0
      }
    }
  },
  computed: {
    orderStateEnums () {
      return this.$store.state.orderState
    },
    orderBrands () {
      return this.$store.state.orderBrands || []
    },
    buyerId () {
      return this.$route.query.buyerId ? +this.$route.query.buyerId : 0
    },
    queryStr () {
      return this.$route.query
    },
    repos () {
      return (this.$store.state.shops || []).map(t => t.name)
    },
    subSellers () {
      return this.$store.state.subSellers || []
    }
  },
  watch: {
    queryStr: {
      handler (newValue, oldValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.updateQuery()
          this.doLoadData()
        }
      },
      deep: true
    },
    newAdd () {
      this.doLoadData()
    },
    area () {
      this.doLoadData()
    }
  },
  beforeMount () {
    if (!this.orderBrands.length) {
      this.$store.dispatch('loadOrderBrands')
    }
  },
  created () {
    this.updateQuery()
  },
  mounted () {
    this.doLoadData()
  },
  methods: {
    doQuery () {
      this.pagination.pageIndex = 1
      this.updateRoute()
    },
    updateQuery () {
      const { orderSn, part, brand, buyer, orderType, orderState, timePayEnd, timePayStart, warehouse, pageIndex, pageSize, subSellerId } = this.$route.query
      this.query.orderSn = orderSn
      this.query.part = part
      this.query.brand = brand
      this.query.buyer = buyer
      this.query.orderType = +orderType || undefined
      this.query.orderState = +orderState || undefined
      this.query.timePayEnd = timePayEnd
      this.query.timePayStart = timePayStart
      this.query.warehouse = warehouse
      this.query.subSellerId = +subSellerId || undefined
      this.pagination.pageIndex = (+pageIndex && +pageIndex > 0) ? +pageIndex : 1
      this.pagination.pageSize = (+pageSize && +pageSize > 0) ? +pageSize : 30
    },
    updateRoute () {
      const { pageIndex, pageSize } = this.pagination
      const { orderSn, part, brand, buyer, orderType, orderState, timePayEnd, timePayStart, warehouse, subSellerId } = this.query
      this.$router.push({
        query: { buyerId: this.buyerId, orderSn, part, brand, buyer, orderType, orderState, timePayEnd, timePayStart, warehouse, subSellerId, pageIndex, pageSize, t: new Date().getTime() }
      })
      this.doLoadData()
    },
    updateState (newState) {
      this.query.orderState = newState
      this.pagination.pageIndex = 1
      this.updateRoute()
    },
    doLoadData () {
      if (this.loading) return
      this.loading = true
      const { pageIndex, pageSize } = this.pagination
      const { orderSn, part, brand, buyer, orderType, orderState, timePayEnd, timePayStart, warehouse, subSellerId } = this.query
      ListOrder({
        orderSn: orderSn || undefined,
        part: part || undefined,
        brandCode: brand && brand.length ? brand.join(',') : undefined,
        buyerInfo: this.buyerId ? undefined : buyer || undefined,
        orderType: orderType || 0,
        state: orderState,
        startTime: timePayStart,
        endTime: timePayEnd,
        warehouse: warehouse || undefined,
        subSellerId: +subSellerId || undefined,
        buyerId: this.buyerId,
        newAdd: this.newAdd,
        area: this.area || undefined,
        pageIndex,
        pageSize
      }).then((resp) => {
        this.statistics = resp.statistics
        this.list = resp.items
        const { pageIndex, pageSize, totalCount } = resp.pagination
        this.pagination.pageIndex = pageIndex
        this.pagination.pageSize = pageSize
        this.pagination.totalCount = totalCount
        this.loadOpsViewer(resp.items.filter(o => o.state === 3 && o.timePay < Config.itemSourceEffectTime))
        this.loadSourceViewer(resp.items.filter(o => o.timePay !== null && o.timePay > Config.itemSourceEffectTime))
      }).finally(() => {
        this.loading = false
      })
    },
    loadOpsViewer (orders) {
      const opsPart = [];
      (orders || []).forEach(order => {
        order.orderItems.forEach(part => {
          if ((part.quantity - part.quantityDelivered - part.quantityReturn) > 0 && part.brandCode && order.timePay < Config.itemSourceEffectTime) {
            opsPart.push({
              brandCode: part.brandCode,
              partCode: part.supersession || part.partCode,
              quality: part.quality === '原厂件' ? 1 : 4
            })
          }
        })
      })
      const toQuery = _.uniqBy(opsPart, o => `${o.brandCode}_${o.partCode}_${o.quality}`)
      const promises = []
      const opsInfoAll = []
      for (let i = 0; i < toQuery.length; i += 600) {
        const sliceQuery = toQuery.slice(i, i + 600)
        promises.push(this.sliceLoadOpsInfo(sliceQuery, opsInfoAll))
      }
      return Promise.all([...promises]).then(() => {
        orders.forEach(order => {
          order.orderItems.forEach(part => {
            if ((part.quantity - part.quantityDelivered - part.quantityReturn) > 0 && part.brandCode && order.state === 3 && order.timePay < Config.itemSourceEffectTime) {
              const apiOpsInfo = _.find(opsInfoAll, o => o.brandCode === part.brandCode && o.partCode === (part.supersession || part.partCode) && o.quality === (part.quality === '原厂件' ? 1 : 0))
              if (apiOpsInfo) {
                const opsInfo = _.cloneDeep(apiOpsInfo)
                this.stockProcessed(opsInfo, order.id)
                this.$set(part, 'opsInfo', opsInfo)
              } else {
                this.$set(part, 'stock', 0)
              }
            }
          })
        })
      })
    },
    loadSourceViewer (orders) {
      const orderItemIds = []
      orders.forEach(order => {
        orderItemIds.push(...order.orderItems.map(t => t.id))
      })
      if (orderItemIds.length) {
        LoadSourceInfo(orderItemIds).then(resp => {
          orders.forEach(order => {
            order.orderItems.forEach(orderItem => {
              this.$set(orderItem, 'itemSources', resp.filter(t => t.orderItemId === orderItem.id))
            })
          })
        })
      }
    },
    stockProcessed (opsInfo, currentOrderId) {
      opsInfo.stock.forEach(repo => {
        repo.state = this.calculateState(opsInfo, repo, currentOrderId)
        repo.stockInInfos = _.filter(opsInfo.stockInfo, o => o.shopId === repo.shopId)
      })
    },
    calculateState (opsInfo, repo, currentOrderId) {
      const sumDemand = _.sumBy(opsInfo.orderDemand, o => o.quantity - o.quantityDelivered)
      if (repo.quantity >= sumDemand) {
        return 2
      }
      const currentOrder = _.find(opsInfo.orderDemand, o => o.orderId === currentOrderId)
      if (currentOrder !== null) {
        if (repo.quantity >= (currentOrder.quantity - currentOrder.quantityDelivered)) {
          return 1
        }
      }
      return 0
    },
    sliceLoadOpsInfo (toQuery, opsInfo) {
      return LoadOpsInfo(toQuery).then((resp) => {
        if (resp && resp.length) {
          opsInfo.push(...resp)
          return resp
        } else {
          return []
        }
      })
    },
    doReset () {
      this.pagination = {
        pageIndex: 1,
        pageSize: 30,
        totalCount: 0
      }
      if (this.buyerId) {
        this.$router.push({ query: {
          t: new Date().getTime()
        } })
      } else {
        this.query = {
          orderSn: undefined,
          part: undefined,
          brand: [],
          buyer: undefined,
          orderType: undefined,
          timePayEnd: undefined,
          timePayStart: undefined,
          warehouse: undefined,
          subSellerId: undefined
        }
      }
      this.updateRoute()
    },
    calcStateCount (state) {
      if (!state) {
        return 0
      }
      const stateStatistic = this.statistics.find(s => s.state === state)
      return (stateStatistic && stateStatistic.count) || 0
    }
  }
}
</script>
